<template>
<svg viewBox="0 0 4.5 12">
<path fill="currentColor" d="M4.418,9.54c0.11,0.11,0.11,0.288,0,0.398l-1.969,1.98c-0.11,0.11-0.288,0.11-0.398,0l-1.969-1.98
	c-0.11-0.11-0.11-0.288,0-0.398l0.166-0.166c0.11-0.11,0.288-0.11,0.398,0l1.206,1.217V1.409L0.646,2.626
	c-0.11,0.11-0.288,0.11-0.398,0L0.082,2.46c-0.11-0.11-0.11-0.288,0-0.398l1.969-1.98c0.11-0.11,0.288-0.11,0.398,0l1.969,1.98
	c0.11,0.11,0.11,0.288,0,0.398L4.252,2.626c-0.11,0.11-0.288,0.11-0.398,0L2.648,1.409v9.182l1.206-1.217
	c0.11-0.11,0.288-0.11,0.398,0L4.418,9.54z"/>
</svg>
</template>
